import React from 'react'
import "./Widgets.css"
import InfoIcon from "@material-ui/icons/Info"
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord"
function Widgets() {
    const newsArticle=(heading,subtitle)=>(
        <div className="widgets_article">
            <div className="widgets_articleleft">
<FiberManualRecordIcon/>
            </div>
            <div className="widgets_articleright">
                <h4>{heading}</h4>
                <p>{subtitle}</p>
            </div>
        </div>
    )
    return (
        <div className="widgets">
            <div className="widgets_header">
                <h2>LinkedIn news</h2>
                <InfoIcon />
            </div>
            {newsArticle("Elon Musk did it again!","Top-news- 2344 readers")}
            {newsArticle("Doge to the Moon!","Dogecoin's value increases sharply- 254 readers")}
            {newsArticle("Harvard is not the best university in the world?","Top-news- 534 readers")}
            {newsArticle("Should you invest in stocks right now?","Top-news- 2423 readers")}
            {newsArticle("UN notifies for alien aproach","Top-news- 14k readers")}
            {newsArticle("Who is going to win the Euro2020?","Top-news- 214 readers")}
        </div>
        
    )
}

export default Widgets
